// extracted by mini-css-extract-plugin
module.exports = {"root":"FocusAreaFilter_root__Xaxr4","focusAreasList":"FocusAreaFilter_focusAreasList__usb4B","button":"FocusAreaFilter_button__K5C8J"};